import { forwardRef } from 'react'

import { Box, Loader, BoxProps } from '@mantine/core'

import { cn } from 'src/utils'

const buttonVariants = {
  primary:
    'bg-doubleNickel-brand-500 text-white hover:bg-doubleNickel-brand-400',
  secondary:
    'bg-doubleNickel-gray-100 text-doubleNickel-gray-700 hover:bg-doubleNickel-gray-200',
  error: 'bg-doubleNickel-error-500 text-white hover:bg-doubleNickel-error-400',
  success:
    'bg-doubleNickel-success-500 text-white hover:bg-doubleNickel-success-400',
  warning:
    'bg-doubleNickel-warning-500 text-white hover:bg-doubleNickel-warning-400',
  transparent:
    'bg-transparent text-doubleNickel-gray-700 hover:bg-doubleNickel-gray-50',
  link: 'bg-transparent text-doubleNickel-brand-500 hover:bg-doubleNickel-gray-50 font-semibold',
  outline:
    'border border-doubleNickel-gray-300 text-doubleNickel-gray-700 hover:bg-doubleNickel-gray-200',
}

interface DNButtonProps extends BoxProps {
  loading?: boolean
  className?: string
  children?: React.ReactNode
  variant?: keyof typeof buttonVariants
  onClick?: () => void
  disabled?: boolean
  type?: 'button' | 'submit' | 'reset'
}

const DNButton = forwardRef<HTMLButtonElement, DNButtonProps>(
  (
    {
      loading = false,
      className = '',
      children,
      variant = 'outline',
      onClick,
      disabled = false,
      type = 'button',
      ...props
    },
    ref
  ) => {
    return (
      <Box
        ref={ref}
        component="button"
        type={type}
        disabled={disabled}
        aria-disabled={disabled}
        onClick={disabled ? undefined : onClick}
        className={cn(
          'flex max-h-9 cursor-pointer flex-row items-center justify-center gap-1 text-nowrap rounded p-2 text-xs font-medium',
          buttonVariants[variant],
          disabled && 'cursor-not-allowed opacity-50',
          className
        )}
        {...props}
      >
        {loading ? <Loader size={16} color="white" /> : children}
      </Box>
    )
  }
)

export default DNButton
